/**
 * TOSS Web Application - Shared Infinite Query Pagination Options
 *
 * Page-param options shared by every page-number based useInfiniteQuery hook
 * in hooks/api/**. Extracted verbatim from the call sites that inlined them.
 */

import type { PaginatedResponse } from '@/types';

/**
 * Page-param options for page-number based infinite queries.
 *
 * Spread into the useInfiniteQuery options object in the position the inline
 * block occupied; per-hook keys (queryKey, queryFn, staleTime, enabled, ...)
 * stay written around it.
 */
export const pagedInfiniteOptions = {
  getNextPageParam: (lastPage: PaginatedResponse<unknown>) =>
    lastPage.hasNextPage ? lastPage.pageNumber + 1 : undefined,
  getPreviousPageParam: (firstPage: PaginatedResponse<unknown>) =>
    firstPage.hasPreviousPage ? firstPage.pageNumber - 1 : undefined,
  initialPageParam: 1,
} as const;
